import React, { useState } from "react";
import { getDayOfWeekByOffset } from "../../../../utils/utils";
import useLoginAction from "../../../../hooks/useLoginAction";
import { useTranslation } from "react-i18next";
import { API_CASINO } from "../../../../api/casino";
import ShowContainer from "../../../mui/ShowContainer";
import CusButton from "../../../mui/custom_button/CusButton";

export default function CashbackDay({
  timeZone,
  bonus,
  indx,
  currency,
  isWelcomeActive,
  thenRequest,
  cashbackId
}) {
  const { onLoginAction } = useLoginAction();
  const { t } = useTranslation();

  const curDay = getDayOfWeekByOffset(timeZone);
  const [btnLoading, setBtnLoading] = useState(false);

  const activeClass = curDay === indx + 1 ? "active" : "";

  const onBonusClick = async (bonus) => {
    const data = {
      bonusId: cashbackId,
      packetNo: bonus.id,
      status: bonus.sendStatus,
      currency: currency
    };
    setBtnLoading(true);

    API_CASINO.bonus
      .setActive(data)
      .then(async (e) => {
        console.log("e", e);
        await thenRequest(bonus.sendStatus);
        setBtnLoading(false);
      })
      .catch((e) => {
        console.error(e);
        setBtnLoading(false);
      });
  };

  return (
    <div key={indx} className={`bonus bonus__cashback ${activeClass}`}>
      <h4>{t(bonus.title)}</h4>
      <div className="bonus__info">
        <div className="bonus__cashback__stepper">
          {bonus.stepper.map((curStep, indx) => (
            <div key={indx} className="bonus__step">
              <div className="bonus__step__row deposit">
                <span>{t("Deposit from")}: </span>
                <span className="currency">
                  {curStep.minDeposit} {currency}
                </span>{" "}
              </div>
              <div className="bonus__step__row">
                <span className="label">{t("Bonus")}</span>
                <span>
                  <span className="percent">{curStep.percent}%</span> (
                  {curStep.wager ? t("wager x", { wager: curStep.wager }) : ""}{" "}
                  {curStep.cashout ? t("cashout x", { cashout: curStep.cashout }) : ""}){" "}
                </span>
              </div>
              <div className="bonus__step__row">
                <span className="label">{t("Accrued")}</span>

                <span>
                  <span className="currency">
                    {" "}
                    {curStep.accrued} {currency}
                  </span>{" "}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bonus__cashback__bottom">
        <ShowContainer condition={bonus.accrued}>
          <span className="bonus__cashback__bottom__label">
            {t("accrued at the moment")} <span className="accent">{bonus.accrued}</span>
          </span>
        </ShowContainer>

        <span className="bonus__cashback__bottom__label">
          {bonus.toDeposit ? t("Crediting to Deposit Balance") : t("Crediting to Bonus Balance")}
        </span>
        <ShowContainer condition={bonus.statusForUser}>
          <span className="bonus__cashback__bottom__label">
            {t("status")}: <span className="accent">{bonus.statusForUser}</span>
          </span>
        </ShowContainer>
        <ShowContainer condition={!isWelcomeActive && bonus.btnText}>
          <CusButton
            className="bonus__btn"
            text={bonus.btnText}
            onClick={() => onLoginAction(() => onBonusClick(bonus))}
            disable={btnLoading || bonus.isDisabled}
          />
        </ShowContainer>
      </div>
    </div>
  );
}
